<div class="step-header" role="banner">
  <div class="container-header">
    <button
      class="container-child icon-header"
      title="Voltar"
      attr.aria-label="Voltar"
      (click)="backClick.emit()"
      tabindex="1"
      #backButton
    ></button>
    <div
      role="heading"
      aria-level="1"
      attr.aria-label="{{ title }} passo {{ currentStep }} de {{ steps }}"
      class="container-child title-header"
    >
      <div aria-hidden="true">
        <p class="ids-pt-2 header-title">{{ title }}</p>
        <span class="header-subtitle">passo {{ currentStep }} de {{ steps }}</span>
      </div>
      <div aria-hidden="true" class="loading-bar-background ids-mt-2 ids-mb-2 ids-mh-2">
        <div class="loading-bar" #loadingBar></div>
      </div>
    </div>
    <button
      class="container-child icon-header"
      title="{{ additionalIconLabel }}"
      (click)="additionalIconClick.emit()"
    >
      <i attr.class="icon {{ additionalIcon }} "></i>
    </button>
  </div>
</div>
